import React from 'react';

export default function Footer() {
    return(
        <div class="footer">
         <h2>Sandra Sanders Portfolio 2/11/2022</h2>
        </div>
    )
}